import { useQueryClient, useMutation } from "@tanstack/react-query"
import { fetcher } from "../fetcher"
import { getDeviceId } from "../../utils/deviceId"

type StartKycResponse = {
  tokenId: string
  linkToken: string
  expiration: string
}

export function useStartKyc() {
  const queryClient = useQueryClient()

  return useMutation<StartKycResponse, unknown, void>({
    mutationFn: async () => {
      const response = await fetcher(
        "/Verification/StartKyc",
        {
          method: "POST",
          body: JSON.stringify({
            deviceId: getDeviceId(),
          }),
        },
        {
          useAccessToken: true,
        }
      )

      const responseJson = await response.json()

      return responseJson
    },
    onSuccess: (response) => {
      queryClient.setQueryData(["StartKyc"], response)
    },
    onError: (error) => {
      console.log("error?", error)
    },
  })
}
